import { Component, Input } from '@angular/core';
import { EventTrackingLogRow } from '../../models/analytics.types';

@Component({
  selector: 'tangram-pa-event-tracking-tab',
  templateUrl: './event-tracking-tab.component.html',
  styleUrls: ['./event-tracking-tab.component.scss']
})
export class EventTrackingTabComponent {
  @Input() rows: EventTrackingLogRow[] = [];
}
